var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup" }, [
    _c("div", { staticClass: "popup_block" }, [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.closeModal()
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: " resume_tariff" }, [
        _c("div", [
          !_vm.failed
            ? _c("h1", [_vm._v("Spasi tenam incha linum")])
            : _c("h1", { staticStyle: { color: "red" } }, [
                _vm._v("Chi hajoxvel ,Dimeq CvWeb-i jekavarutyany ")
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c74fd2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c74fd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/buyTariff/modalBuyLoad.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-70c74fd2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/buyTariff/modalBuyLoad.vue
// module chunks = 0